export default "__VITE_ASSET__6pEEFNnH__"